import React, { useEffect, useState } from "react";
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native'
import { responsiveFontSize, responsiveWidth } from "react-native-responsive-dimensions";
import { Ionicons, MaterialCommunityIcons } from "@expo/vector-icons";
import * as Linking from 'expo-linking';

import { sendZap } from "../services/sendMsgZap";
import colors from "../styles/colors";
import { sendNotification } from "../utils/apiSendNotification";
import MyText from "../components/MyText";

const phone = '+14155238886'
export default function SucessOrder({ navigation, route }) {
    const [id, setId] = useState(null)
    const [pMode, setPMode] = useState('')
    useEffect(() => {
        const { id, user, order } = route.params;
        setId(id)
        setPMode(order.paymentMode);

        sendNotification('Novo Pedido 🔔 ',`${user.name} fez um novo pedido. ✅`);
    }, [])
    return (
        <View style={styles.container}>
            <MyText style={styles.emoji}>😋</MyText>
            <MyText style={styles.title}>Pedido Realizado com Sucesso ✅</MyText>
            <MyText style={styles.subTxt}>Avisaremos você assim que houver alguma alteração do seu pedido.</MyText>
            {pMode === 'Pix' && (
                <View style={styles.containerPix}>
                    <MyText style={styles.pixTxt}> Chave Pix:</MyText>
                    <MyText style={styles.pixTxt}> 94984337492 </MyText>
                    <MyText style={styles.pixTxt}> Raissa Marley Dantas de Oliveira</MyText>
                    <MyText style={styles.pixTxt}> Por gentileza, enviar o comprovante no WhatsApp, obrigado 🫶🏻. </MyText>
                </View>

            )}
            <TouchableOpacity style={styles.btnZap} onPress={() => { navigation.navigate('Tabs',{screen: 'Orders'}) }}>
                <Ionicons name="receipt-outline" size={24} color="white" />
                <MyText style={styles.btnTxt}>Acompanhar pedido</MyText>
            </TouchableOpacity>
            <TouchableOpacity style={styles.btnHome} onPress={() => { navigation.navigate('Home') }}>
                <MaterialCommunityIcons name="home-circle-outline" size={24} color="white" />
                <MyText style={styles.btnTxt}>Voltar para o início</MyText>
            </TouchableOpacity>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
    },
    emoji: {
        fontSize: responsiveFontSize(15)
    },
    title: {
        fontSize: responsiveFontSize(2),
        marginTop: responsiveWidth(10)
    },
    subTxt: {
        marginVertical: responsiveWidth(2),
        marginHorizontal: responsiveWidth(3),
        fontSize: responsiveFontSize(1.9),
        color: colors.gray2,
        textAlign: 'center'
    },
    btnZap: {
        flexDirection: 'row',
        width: responsiveWidth(90),
        height: responsiveWidth(15),
        backgroundColor: colors.zapColor,
        borderRadius: 5,
        justifyContent: 'center',
        alignItems: 'center',
        marginVertical: responsiveWidth(5)
    },
    btnHome: {
        flexDirection: 'row',
        width: responsiveWidth(90),
        height: responsiveWidth(15),
        backgroundColor: colors.red,
        borderRadius: 5,
        justifyContent: 'center',
        alignItems: 'center',
    },
    btnTxt: {
        color: 'white',
        fontSize: responsiveFontSize(1.8),
        fontWeight: 'bold',
        marginHorizontal: responsiveWidth(5)
    },
    containerPix: {
        borderWidth: responsiveFontSize(0.1),
        borderColor: 'gray',
        borderRadius: responsiveFontSize(0.5),
        padding: responsiveFontSize(1)
    },
    pixTxt: {
        fontSize: responsiveFontSize(1.4),
        lineHeight: responsiveFontSize(2.5)
    }
})